import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { GetService, PostService } from "../../../../Services/ConstantService";
import { API_URL } from "../../../../Services/ApiService";
import { showErrorAlert } from "../../../../Helper/SweetAlert";
import { MoonLoader } from "react-spinners";
import defaultImg from "../../../../assets/img/thumbnail.png";
import { format } from "date-fns";
import { Spinner } from "react-bootstrap/esm";

export default function ViewOrder() {
  const [orderDetails, setorderDetails] = useState();
  const [S_No_Count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [selectedState, setselectedState] = useState("");
  const [OrderImage, setOrderImage] = useState(false);
  const [viewItemDetails, setviewItemDetails] = useState("");
  const [Downloadloading, setDownloadLoading] = useState(false);
  const { id } = useParams();

  const status = [
    {
      status_name: "Order Placed",
      status_class: "fa-solid fa-bag-shopping",
      tracking_no: 0,
    },
    {
      status_name: "Creating Order",
      status_class: "fa-solid fa-gift",
      tracking_no: 1,
    },
    {
      status_name: "Shipping",
      status_class: "fa-solid fa-truck",
      tracking_no: 2,
    },
    {
      status_name: "Out For Delivery",
      status_class: "fa-solid fa-truck-fast",
      tracking_no: 3,
    },
    {
      status_name: "Delivered",
      status_class: "fa-solid fa-truck-ramp-box",
      tracking_no: 4,
    },
  ];

  function gettrackingNumber(curstatus) {
    const trackingNumber = status?.findIndex(
      (i) => i.status_name === curstatus
    );
    return trackingNumber;
  }

  const getOrderDetails = () => {
    setLoading(true);
    GetService(`${API_URL.ORDER_BY_ID}?id=${id}`).then((res) => {
      console.log(res?.data?.status);
      if (res?.data?.status === true) {
        setorderDetails(res?.data?.data);
        setLoading(false);
      } else {
        showErrorAlert(res.data?.message);
        setLoading(false);
      }
    });
  };
  useEffect(() => {
    getOrderDetails();
  }, []);

  function getOrderImageDownload(itemImages) {
    setDownloadLoading(true);
    const data = [];
    if (itemImages) {
      const image = JSON.parse(itemImages);
      for (let i of image) {
        data.push(i);
      }
      PostService(API_URL.GET_IMAGE, { images: data }).then((res) => {
        setDownloadLoading(false);
        if (res?.data?.status) {
          res?.data?.data.forEach((image, index) => {
            handleDownload(image, ``);
          });
        }
      });
    }
  }
  const handleDownload = (url, fileName) => {
    console.log(url);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h3>View Order</h3>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <Link
                  to="/panel/dashboard"
                  className="breadcrumb-item"
                  style={{ textDecoration: "none" }}
                >
                  Dashboard
                </Link>
                <Link
                  to="/panel/order"
                  className="breadcrumb-item"
                  style={{ textDecoration: "none" }}
                >
                  Order List
                </Link>
                <Link className="breadcrumb-item active">View Order</Link>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <div class="card">
        <div class="card-body orderdetails">
          <div className="d-flex justify-content-between">
            <h4 className="pl-3">Order Details</h4>
            <h4 className="mx-2">
              OrderId -{" "}
              <span className="text-primary">
                {orderDetails?.billingData?.order_no}
              </span>
            </h4>
          </div>
          <hr className="mt-0" />
          <div className="mt-3 mx-0 row">
            <div className="col-md-6">
              <div className="d-flex justify-content-start">
                <div className="text-muted">
                  <p className="fa-1x font-weight-bold">Name :</p>
                  <p className="fa-1x font-weight-bold">Email :</p>
                  <p className="fa-1x font-weight-bold">Contact :</p>
                  <p className="fa-1x font-weight-bold">Address :</p>
                </div>
                <div className="ml-2">
                  <p className="fa-1x">
                    {orderDetails?.billingData?.registration?.fullName}
                  </p>
                  <p className="fa-1x">{orderDetails?.billingData?.bemailid}</p>
                  <p className="fa-1x">{orderDetails?.billingData?.bphone}</p>
                  <p className="fa-1x">
                    {orderDetails?.billingData?.baddress1},
                  </p>
                  <p className="fa-1x">
                    {orderDetails?.billingData?.bcity ? (
                      <span className="">
                        {orderDetails?.billingData?.bcity} (
                        {orderDetails?.billingData?.bzip}),
                      </span>
                    ) : (
                      ""
                    )}{" "}
                  </p>
                  <p className="fa-1x">
                    {orderDetails?.BState?.state_name ? (
                      <span className="">
                        {orderDetails?.BState?.state_name},
                      </span>
                    ) : (
                      ""
                    )}{" "}
                    {orderDetails?.BCountry?.country_name ? (
                      <span className="">
                        {orderDetails?.BCountry?.country_name}
                      </span>
                    ) : (
                      ""
                    )}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="d-flex justify-content-end">
                <div className="text-muted">
                  <p className="fa-1x font-weight-bold">Transaction Id :</p>
                  <p className="fa-1x font-weight-bold">Order Date :</p>
                  <p className="fa-1x font-weight-bold">Payment Mode :</p>
                  <p className="fa-1x font-weight-bold">Payment Status :</p>
                  <p className="fa-1x font-weight-bold">Order Status :</p>
                  <p className="fa-1x font-weight-bold">Total Order Value :</p>
                </div>
                <div className="ml-4">
                  <p className="fa-1x">
                    {orderDetails?.paymentData?.transaction_id}
                  </p>
                  <p className="fa-1x">
                    {" "}
                    {orderDetails?.billingData?.created_at
                      ? format(
                          new Date(orderDetails?.billingData?.created_at),
                          "dd/MM/yyyy, HH:mm"
                        )
                      : "N/A"}
                  </p>
                  <p className="fa-1x text-capitalize">
                    {orderDetails?.paymentData?.payment_method}
                  </p>
                  <p className="fa-1x">{orderDetails?.paymentData?.status}</p>
                  <p className="fa-1x">
                    {orderDetails?.billingData?.order_status}
                  </p>
                  <p
                    className="font-weight-bold text-primary"
                    style={{ fontSize: "large" }}
                  >
                    ${orderDetails?.billingData?.total_amount}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="table-responsive mt-3">
            <table class="table table-hover table-bordered table-striped">
              <thead>
                <tr>
                  {/* <th>S.No</th> */}
                  <th>Preview</th>
                  <th>Product</th>
                  <th>Item Price</th>
                  <th>Quantity</th>
                  <th>Edge/Services</th>
                  <th>Total ($)</th>
                </tr>
              </thead>
              <tbody>
                {orderDetails?.billingData?.orderItems.map((item, i) => (
                  <tr key={i}>
                    {/* <td>{i + S_No_Count + 1}</td> */}
                    <td>
                      <div
                        className="cursor position-relative"
                        onClick={() => {
                          setselectedState(item);
                          setOrderImage(true);
                        }}
                      >
                        {item?.orderItems?.length > 1 && (
                          <span
                            className="bg-primary p-1 position-absolute text-white text-small"
                            style={{ opacity: ".7" }}
                          >
                            +{item?.orderItems?.length - 1}
                          </span>
                        )}
                        <img
                          src={item?.MergedImage}
                          alt=""
                          onError={(e) => {
                            e.target.src = defaultImg;
                          }}
                        />
                      </div>
                    </td>
                    <td className="prod-list">
                      <ul>
                        <li className="p-1 fw-semibold text-primary">
                          {item?.Layout === "gallery_wall" ||
                          item?.Layout === "Gallery Wall"
                            ? "Gallery Wall"
                            : item?.Layout === "story_canvas" ||
                              item?.Layout === "storyCanvas"
                            ? "Story Canvas"
                            : item?.Layout === "split_canvas" ||
                              item?.Layout === "Split Canvas"
                            ? "Split Canvas"
                            : item?.Layout === "single_panel" ||
                              item?.Layout === "Single Panel"
                            ? "Single Canvas"
                            : item?.Layout === "plexi_print" ||
                              item?.Layout === "Plexi Print"
                            ? "Plexi Print"
                            : item?.Layout === "art_tray" ||
                              item?.Layout === "Art Tray"
                            ? "Art Tray"
                            : item?.Layout === "wood_print" ||
                              item?.Layout === "Wood Print"
                            ? "Wood Print"
                            : item?.Layout === "diamond_dust" ||
                              item?.Layout === "Diamond Dust"
                            ? "Diamond Dust"
                            : item?.Layout}
                        </li>
                        {(item?.Layout === "single_panel" ||
                          item?.Layout === "Single Panel") && (
                          <li
                            className="px-1 pb-1"
                            style={{ fontSize: "14px" }}
                          >
                            {item?.type === "framed"
                              ? "Framed"
                              : item?.type === "thinGallery"
                              ? "Thin Gallery Wrap (0.75)"
                              : item?.type === "thickGallery"
                              ? "Thick Gallery Wrap (1.5)"
                              : item?.type === "rolled"
                              ? "Rolled in a Tube"
                              : ""}
                          </li>
                        )}
                        {(item?.Layout === "split_canvas" ||
                          item?.Layout === "Split Canvas") && (
                          <li
                            className="px-1 pb-1"
                            style={{ fontSize: "14px" }}
                          >
                            {item?.size_detail?.panels === 2
                              ? "DYPTYCHS"
                              : "TRYPTYCHS"}{" "}
                            -{" "}
                            {item?.size_detail?.price
                              ? "Standard 3/4"
                              : "Thick 1 1/2"}
                          </li>
                        )}
                        <li className="px-1 pb-1">
                          {" "}
                          {item?.size_detail?.size}
                        </li>
                        {item?.size_detail?.suggested_Items &&
                                  <li className="px-1 pb-1">
                                    <small>{"(Excluded discount)"}</small>
                                </li>
                                }
                      </ul>
                    </td>
                    <td>{item?.size_detail?.thick_price?item?.size_detail?.thick_price:item?.size_detail?.price || item?.price}</td>
                    <td>{item?.quantity}</td>
                    <td className="text-left ml-2">
                      <p className="fa-1x font-weight-bold pl-2">
                        Edge :
                        <span className="font-weight-lighter ml-1">
                          {`${item?.Edge?.edge ? item?.Edge?.edge : "None"} ${
                            item?.Edge?.price ? `($${item?.Edge?.price})` : ""
                          }`}
                        </span>
                      </p>
                      <p className="fa-1x font-weight-bold pl-2">
                        Effects :
                        <span className="font-weight-lighter ml-1">
                          {`${
                            item?.Services?.Effects?.name
                              ? item?.Services?.Effects?.name
                              : "None"
                          } ${
                            item?.Services?.Effects?.price
                              ? `($${item?.Services?.Effects?.price})`
                              : ""
                          }`}
                        </span>
                      </p>
                      <p className="fa-1x font-weight-bold pl-2">
                        Retouching :
                        <span className="font-weight-lighter ml-1">
                          {`${
                            item?.Services?.Retouching?.name
                              ? item?.Services?.Retouching?.name
                              : "None"
                          } ${
                            item?.Services?.Retouching?.price
                              ? `($${item?.Services?.Retouching?.price})`
                              : ""
                          }`}
                        </span>
                      </p>
                    </td>

                    <td className="font-weight-bold text-primary">
                      {item?.price}
                    </td>
                  </tr>
                ))}
              </tbody>
              {orderDetails && (
                <tr>
                  <td colSpan="10" className="text-center">
                    <div className="d-flex justify-content-between">
                      <div>
                        {orderDetails?.billingData?.delivery_partner?.name && (
                          <div className="d-flex mt-3 mr-3">
                            <div className="text-left">
                              <img
                                src={
                                  orderDetails?.billingData?.delivery_partner
                                    ?.delivery_partner_logo
                                }
                                alt=""
                                height="100px"
                                width="100px"
                                style={{ objectFit: "contain" }}
                              />
                            </div>
                            <div className="d-flex text-left">
                              <div className="ml-3">
                                <p className="font-weight-bold">
                                  {
                                    orderDetails?.billingData?.delivery_partner
                                      ?.name
                                  }
                                </p>
                                <p>
                                  {" "}
                                  {
                                    orderDetails?.billingData?.delivery_partner
                                      ?.email
                                  }
                                </p>
                                <p>
                                  {" "}
                                  {
                                    orderDetails?.billingData?.delivery_partner
                                      ?.phoneNumber
                                  }
                                </p>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="d-flex mt-3">
                        <div className="text-right">
                          <p className="fa-1x font-weight-bold">
                            Sub Total($) :
                          </p>
                           <p className="fa-1x font-weight-bold">
                            Discount($) :
                          </p>

                          <p className="fa-1x font-weight-bold">
                            Shipping($) :
                          </p>
                          <p className="fa-1x font-weight-bold">
                            Tax($) :
                          </p>
                         
                          <hr className="mt-0 mb-1" />
                          <p className="fa-1x font-weight-bold">
                            Total Order Value($) :
                          </p>
                        </div>
                        <div className="mx-4 text-right">
                          <p className="fa-1x">
                            {orderDetails?.billingData?.orderSummery?.subtotal}
                          </p>
                           <p className="fa-1x">
                            -{" "}
                            {orderDetails?.billingData?.orderSummery?.discount}
                          </p>

                          <p className="fa-1x">
                            {
                              orderDetails?.billingData?.orderSummery
                                ?.shippingprice
                            }
                          </p>
                           <p className="fa-1x">
                            {
                              orderDetails?.billingData?.orderSummery
                                ?.tax
                            }
                          </p>
                         {" "}
                          <hr className="mt-0 mb-1" />
                          <p className="font-weight-bold">
                            {orderDetails?.billingData?.orderSummery?.total}
                          </p>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              )}
              {orderDetails && orderDetails?.length === 0 && (
                <tr>
                  <td colSpan="5" className="text-center">
                    <h6 className="p-3"> No Data Found </h6>
                  </td>
                </tr>
              )}
              <div
                className={`view_order_image rounded ${
                  OrderImage ? "active_order_image" : ""
                }`}
              >
                {selectedState && OrderImage && (
                  <>
                    <div className="d-flex justify-content-between mt-4 mx-4 text-white">
                      <h3>View Order Image</h3>
                      <i
                        className="fa-solid fa-xmark cursor fa-2x"
                        onClick={() => {
                          setOrderImage(false);
                        }}
                      ></i>
                    </div>
                    <div className="row mx-3 mt-5 d-flex flex-wrap ">
                      {/* view per order */}
                    </div>
                    {selectedState && (
                      <div className="mx-4">
                        <div className="d-flex mt-3 justify-content-between">
                          <div className="ml-4 d-flex">
                            <img
                              src={selectedState?.MergedImage}
                              alt=""
                              height={"100%"}
                              onError={(e) => {
                                e.target.src = defaultImg;
                              }}
                              style={{ maxHeight: "250px" }}
                            />

                            <div className="d-flex justify-content-end text-white ml-5">
                              <div>
                                <p
                                  className="fa-1x font-weight-bold mb-3"
                                  style={{ letterSpacing: "2px" }}
                                >
                                  Layout :
                                </p>

                                {(selectedState?.Layout === "single_panel" ||
                                  selectedState?.Layout === "Single Panel" ||
                                  selectedState?.Layout === "split_canvas" ||
                                  selectedState?.Layout === "Split Canvas") && (
                                  <p
                                    className="fa-1x font-weight-bold mb-3"
                                    style={{ letterSpacing: "2px" }}
                                  >
                                    Type :
                                  </p>
                                )}

                                <p
                                  className="fa-1x font-weight-bold mb-3"
                                  style={{ letterSpacing: "2px" }}
                                >
                                  Order size :
                                </p>
                                <p
                                  className="fa-1x font-weight-bold mb-3"
                                  style={{ letterSpacing: "2px" }}
                                >
                                  Quantity :
                                </p>
                                <p
                                  className="fa-1x font-weight-bold mb-3"
                                  style={{ letterSpacing: "2px" }}
                                >
                                  Layout Price :
                                </p>
                                <p
                                  className="fa-1x font-weight-bold mb-3"
                                  style={{ letterSpacing: "2px" }}
                                >
                                  Edge :
                                </p>
                                <p
                                  className="fa-1x font-weight-bold mb-3"
                                  style={{ letterSpacing: "2px" }}
                                >
                                  Effects :
                                </p>
                                <p
                                  className="fa-1x font-weight-bold mb-3"
                                  style={{ letterSpacing: "2px" }}
                                >
                                  Retouching :
                                </p>

                                {selectedState?.orderSummery?.discount !== 0 &&
                                  selectedState?.orderItems?.length === 1 && (
                                    <p
                                      className="fa-1x font-weight-bold mb-3"
                                      style={{ letterSpacing: "2px" }}
                                    >
                                      Discount :
                                    </p>
                                  )}
                                <div className="mt-3">
                                  <button
                                    className="bg-white btn font-weight-bold py-2"
                                    onClick={() =>
                                      getOrderImageDownload(
                                        selectedState?.images
                                      )
                                    }
                                  >
                                    Download Image{" "}
                                    {Downloadloading ? (
                                      <Spinner
                                        animation="border"
                                        role="status"
                                        className="spinner ml-1"
                                      ></Spinner>
                                    ) : (
                                      <i class="fa-solid fa-download ml-1"></i>
                                    )}
                                  </button>
                                </div>
                              </div>
                              <div className="ml-4">
                                <p className="fa-1x mb-3">
                                  {selectedState?.Layout === "gallery_wall" ||
                                  selectedState?.Layout === "Gallery Wall"
                                    ? "Gallery Wall"
                                    : selectedState?.Layout ===
                                        "story_canvas" ||
                                      selectedState?.Layout === "storyCanvas"
                                    ? "Story Canvas"
                                    : selectedState?.Layout ===
                                        "split_canvas" ||
                                      selectedState?.Layout === "Split Canvas"
                                    ? "Split Canvas"
                                    : selectedState?.Layout ===
                                        "single_panel" ||
                                      selectedState?.Layout === "Single Panel"
                                    ? "Single Canvas"
                                    : selectedState?.Layout === "plexi_print" ||
                                      selectedState?.Layout === "Plexi Print"
                                    ? "Plexi Print"
                                    : selectedState?.Layout === "art_tray" ||
                                      selectedState?.Layout === "Art Tray"
                                    ? "Art Tray"
                                    : selectedState?.Layout === "wood_print" ||
                                      selectedState?.Layout === "Wood Print"
                                    ? "Wood Print"
                                    : selectedState?.Layout ===
                                        "diamond_dust" ||
                                      selectedState?.Layout === "Diamond Dust"
                                    ? "Diamond Dust"
                                    : "-"}
                                </p>

                                {(selectedState?.Layout === "single_panel" ||
                                  selectedState?.Layout === "Single Panel") && (
                                  <p className="fa-1x mb-3">
                                    {selectedState?.type === "framed"
                                      ? "Framed"
                                      : selectedState?.type === "thinGallery"
                                      ? "Thin Gallery Wrap (0.75)"
                                      : selectedState?.type === "thickGallery"
                                      ? "Thick Gallery Wrap (1.5)"
                                      : selectedState?.type === "rolled"
                                      ? "Rolled in a Tube"
                                      : ""}
                                  </p>
                                )}
                                {(selectedState?.Layout === "split_canvas" ||
                                  selectedState?.Layout === "Split Canvas") && (
                                  <p className="fa-1x mb-3">
                                    {selectedState?.size_detail?.panels === 2
                                      ? "DYPTYCHS"
                                      : "TRYPTYCHS"}{" "}
                                    -{" "}
                                    {selectedState?.size_detail?.price
                                      ? "Standard 3/4"
                                      : "Thick 1 1/2"}
                                  </p>
                                )}

                                <p className="fa-1x mb-3">
                                  {selectedState?.size_detail?.size}
                                </p>
                                <p className="fa-1x mb-3">
                                  {selectedState?.quantity}
                                </p>
                                <p className="fa-1x mb-3">
                                  ${selectedState?.size_detail?.thick_price?
                                  selectedState?.size_detail?.thick_price:
                                  selectedState?.size_detail?.price} 
                                </p>
                                <p className="fa-1x mb-3">
                                  {selectedState?.Edge?.edge
                                    ? `${selectedState?.Edge?.edge} ${
                                        selectedState?.Edge?.price
                                          ? `($${selectedState?.Edge?.price})`
                                          : ""
                                      }`
                                    : "None"}
                                </p>
                                <p className="fa-1x mb-3"> 
                                  {selectedState?.Services?.Effects?.name
                                    ? `${
                                        selectedState?.Services?.Effects?.name
                                      } ${
                                        selectedState?.Services?.Effects?.price
                                          ? `($${selectedState?.Services?.Effects?.price})`
                                          : ""
                                      }`
                                    : "None"}
                                </p>
                                <p className="fa-1x mb-3">
                                  {selectedState?.Services?.Retouching?.name ? (
                                    <>
                                      {
                                        selectedState?.Services?.Retouching
                                          ?.name
                                      }
                                      {selectedState?.Services?.Retouching
                                        ?.price ? (
                                        <span>
                                          {" "}
                                          ($
                                          {
                                            selectedState?.Services?.Retouching
                                              ?.price
                                          }
                                          )
                                        </span>
                                      ) : (
                                        ""
                                      )}
                                    </>
                                  ) : (
                                    "None"
                                  )}
                                </p>

                                {selectedState?.orderSummery?.discount !== 0 &&
                                  selectedState?.orderItems?.length === 1 && (
                                    <p className="fa-1x mb-3">
                                      <div>
                                        Promo Code ( {selectedState?.promoCode}{" "}
                                        )
                                      </div>
                                      <div className="mt-2">
                                        {" "}
                                        ($ -
                                        {selectedState?.orderSummery?.discount})
                                      </div>
                                    </p>
                                  )}
                              </div>
                            </div>
                          </div>

                          <div className=" text-white mx-auto">
                            <h4 className="mb-4">Total Price</h4>
                            <p className="fa-2x">
                              $
                              {selectedState?.orderItems?.length === 1
                                ? selectedState.orderSummery?.total
                                : selectedState?.price}
                            </p>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>
            </table>
            <div className="mt-4 ">
              <h3 class="font-weight-bold text-center">Order Status</h3>
              <div class="row  ">
                <div class="col-12">
                  {orderDetails?.billingData?.order_status !==
                    "Cancel Order" && (
                    <ul id="progressbar" class="text-center">
                      {status &&
                        status?.map((item, i) => (
                          <li
                            class={`step0 ${
                              gettrackingNumber(
                                orderDetails?.billingData?.order_status
                              ) >= i
                                ? "active"
                                : ""
                            }`}
                          >
                            <i class={item?.status_class}></i>{" "}
                            {item?.status_name}
                          </li>
                        ))}
                    </ul>
                  )}
                  {orderDetails?.billingData?.order_status ===
                    "Cancel Order" && (
                    <p
                      className="text-danger text-center mt-3"
                      style={{ fontSize: "20px" }}
                    >
                      This Order have been canceled !
                    </p>
                  )}
                </div>
              </div>
            </div>
            {loading ? (
              <div className="LoaderSpinner">
                <MoonLoader
                  color={"#003bff"}
                  loading={loading}
                  speedMultiplier={0.6}
                  size={50}
                />
                <div>Loading... Please wait.</div>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
